<template>
  <footer class="w-full p-4 bg-primary md:p-6">
    <ul class="flex flex-wrap items-center text-sm sm:mt-0 justify-center">
      <li v-for="(item, index) in navItems" :key="index">
        <a :href="item.route" class="mr-4 hover:underline md:mr-6">{{ item.title }}</a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      navItems: this.$page.props.nav_items.footer,
    }
  },
}
</script>
